<template>
  <amf-form :back-color="'#F8F8F8'" class="container">
    <div class="container" v-if="payment">
      <div class="row">
        <div class="col-6">
          <div class="col-12">
            <label><b>Employer</b></label>
            <span>{{ payment.employerName }}</span>
          </div>
          <div class="col-12">
            <label><b>Created Date</b></label>
            <span>{{ $formatters.date(payment.createdAt) }}</span>
          </div>
          <div class="col-12">
            <label><b>Deposit Amount</b></label>
            <span>{{ $formatters.money(payment.paymentAmount) }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="col-12">
            <label><b>Deposit Status</b></label>
            <span v-if="payment.processingStatus > 6">{{
              getStatus(payment.processingStatus)
            }}</span>
            <span v-else>
              <amf-select
                v-model="payment.processingStatus"
                :options="statuses"
                :columns="3"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </amf-form>
</template>

<script>
import { nachaLabels } from "./nacha-labels";

export default {
  data() {
    return {
      payments: [],
      nachaStatus: null,
      nachaId: null,
      payment: null,
    };
  },
  props: {
    bankTransferId: {
      type: Number,
      required: true,
    }
    ,closeEditor: {type: Function}
  },
  computed: {
    footerButtons() {
      return "Save";
    },
    statuses() {
      return nachaLabels.hsaStatuses;
    },
    rejectOptions() {
      return nachaLabels.rejectOptions;
    },
  },
  methods: {
    async load() {
      var paymentDetail = await romeApi.get(
        `banktransfer/hsa/payment/${this.bankTransferId}`
      );

      paymentDetail.forEach((n) => {
        if (n.processingStatus < 5) this.nachaStatus = 0;
      });
      this.payment = paymentDetail[0];
    },

    getStatus(status) {
      switch (status) {
        case 4:
          return "Not selected";
        case 5:
          return "Rejected";
        case 6:
          return "Confirmed";
        case 7:
          return "Transaction Renachaed";
        case 8:
          return "Transaction Reversed";
        case 9:
          return "Transaction Reverse Failed";
        case 10:
          return "Manually Reversed";
      }
    },
    async save() {
      if (this.payment.processingStatus == 6) this.payment.response = null;

      this.payments.push(this.payment);

      var data = {
        bankTransferId: this.bankTransferId,
        payments: this.payments,
      };
      await romeApi.post(`banktransfer/save`, data);
      toastService.success("Record updated.");
      this.closeEditor(this.bankTransferId);
      await this.$store.dispatch("nachas/loadHsaPushBankTransfers");
    },
  },
  watch: {
    bankTransferId() {
      this.load();
    },
  },
  created() {
    this.load();
  },
};
</script>
<style lang="scss" scoped>
label {
  font-weight: 500;
}
label::after {
  content: ":";
}
.planData label + span {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/finance/HsaPushDetail.vue